var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.0037 14.6002V4.96798H1.00773V14.6002H4.0037ZM2.48961 3.67939C3.45605 3.67939 4.22921 2.87402 4.22921 1.90758C4.22921 0.97335 3.45605 0.200195 2.48961 0.200195C1.55538 0.200195 0.782227 0.97335 0.782227 1.90758C0.782227 2.87402 1.55538 3.67939 2.48961 3.67939ZM15.1822 14.6002H15.2144V9.31697C15.2144 6.73979 14.6346 4.74248 11.6064 4.74248C10.1567 4.74248 9.19028 5.54785 8.77149 6.28879H8.73927V4.96798H5.87216V14.6002H8.86813V9.83241C8.86813 8.57603 9.09364 7.38409 10.6399 7.38409C12.1863 7.38409 12.2185 8.80154 12.2185 9.92906V14.6002H15.1822Z","fill":"black"}));
}

Linkedin.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
